import without from 'lodash/without';
import compact from 'lodash/compact';
import * as Tabs from '@radix-ui/react-tabs';
import cx from 'classnames';
import { BiCheckbox, BiCheckboxChecked } from 'react-icons/bi';
import { Field } from 'react-final-form';
import { SelectBrandsMultiple } from '../../../form/SelectBrandsMultiple';
import { SelectMultipleField } from '../../../form/SelectMultipleField';
import startsWith from 'lodash/startsWith';
import React from 'react';
import EverpriceDistribution from './EverpriceDistribution';
import PropertiesTreeWidget  from '../../../utils/PropertiesTreeWidget';

export function GrantTabs({ isGroup, formValues, classificationFilter, everpriceDistributionEnabled, showGiacenzeEnabled, showEverpriceEnabled }) {
    const cleanProperties = without(compact(formValues.properties_ids), 'assets');

    return (
        <Tabs.Root className="TabsRoot" orientation="vertical">
            <Tabs.List className="TabsList" aria-label="Seleziona Grant">
                <Tabs.Trigger
                    className={cx('TabsTrigger', {
                        'TabsTrigger-enabled': formValues.not_allowed_marca_ids.length > 0,
                    })}
                    value="view_marche"
                >
                    {formValues.not_allowed_marca_ids.length > 0 ? (
                        <span className="text-primary">
                            <BiCheckboxChecked className="mr-2" size={28} />
                        </span>
                    ) : (
                        <BiCheckbox className="mr-2" size={28} />
                    )}
                    Marche disabilitate
                </Tabs.Trigger>
                <Tabs.Trigger
                    className={cx('TabsTrigger', {
                        'TabsTrigger-enabled': cleanProperties.length > 0,
                    })}
                    value="view_properties"
                >
                    {cleanProperties.length > 0 ? (
                        <span className="text-primary">
                            <BiCheckboxChecked className="mr-2" size={28} />
                        </span>
                    ) : (
                        <BiCheckbox className="mr-2" size={28} />
                    )}
                    Attributi visualizzabili
                </Tabs.Trigger>
                <Tabs.Trigger
                    className={cx('TabsTrigger', {
                        'TabsTrigger-enabled': formValues.view_product_trees_ids.length > 0,
                    })}
                    value="view_product_trees"
                >
                    {formValues.view_product_trees_ids.length > 0 ? (
                        <span className="text-primary">
                            <BiCheckboxChecked className="mr-2" size={28} />
                        </span>
                    ) : (
                        <BiCheckbox className="mr-2" size={28} />
                    )}{' '}
                    Classificazioni visualizzabili
                </Tabs.Trigger>
                <Tabs.Trigger
                    className={cx('TabsTrigger', {
                        'TabsTrigger-enabled': formValues.view_products_ids.length > 0,
                    })}
                    value="view_products"
                >
                    {formValues.view_products_ids.length > 0 ? (
                        <span className="text-primary">
                            <BiCheckboxChecked className="mr-2" size={28} />
                        </span>
                    ) : (
                        <BiCheckbox className="mr-2" size={28} />
                    )}
                    Filtro prodotti
                </Tabs.Trigger>
                <Tabs.Trigger
                    className={cx('TabsTrigger', {
                        'TabsTrigger-enabled': formValues.delete_products === true,
                    })}
                    value="delete_products"
                >
                    {formValues.delete_products === true ? (
                        <span className="text-primary">
                            <BiCheckboxChecked className="mr-2" size={28} />
                        </span>
                    ) : (
                        <BiCheckbox className="mr-2" size={28} />
                    )}
                    Elimina prodotti
                </Tabs.Trigger>

                {/*Grant view_integrations for everprices*/}
                {showEverpriceEnabled && (
                    <Tabs.Trigger
                        className={cx('TabsTrigger', {
                            'TabsTrigger-enabled': formValues.view_integrations === true || formValues?.everprice_distribution?.ftp_enabled === true,
                        })}
                        value="view_integrations"
                    >
                        {formValues.view_integrations === true || formValues?.everprice_distribution?.ftp_enabled === true ? (
                            <span className="text-primary">
                                <BiCheckboxChecked className="mr-2" size={28} />
                            </span>
                        ) : (
                            <BiCheckbox className="mr-2" size={28} />
                        )}
                        Gestione EVERPRICE®
                    </Tabs.Trigger>
                )}

                {/*Grant giacenze*/}
                {showGiacenzeEnabled && (
                    <Tabs.Trigger
                        className={cx('TabsTrigger', {
                            'TabsTrigger-enabled': formValues.giacenze === true,
                        })}
                        value="giacenze"
                    >
                        {formValues.giacenze === true ? (
                            <span className="text-primary">
                                <BiCheckboxChecked className="mr-2" size={28} />
                            </span>
                        ) : (
                            <BiCheckbox className="mr-2" size={28} />
                        )}
                        Giacenze
                    </Tabs.Trigger>
                )}

            </Tabs.List>
            <Tabs.Content className="TabsContent" value="view_marche">
                {/* <Field
                    name="view_marche.enabled"
                    component={SwitchField}
                    placeholder="Attiva grant"
                    layout="horizontal"
                    type="checkbox"
                /> */}
                <h4 className="border-b-2 border-black">Marche disabilitate</h4>
                <Field name="not_allowed_marca_ids">
                    {(props) => (
                        <SelectBrandsMultiple
                            // label="Marche disabilitate"
                            // labelClass="col-3 col-sm-12"
                            inputWrapperClass="col-6 col-sm-12"
                            value={props.input.value}
                            onChange={props.input.onChange}
                        />
                    )}
                </Field>
            </Tabs.Content>
            <Tabs.Content className="TabsContent" value="view_properties">
                {/* <Field
                    name="view_properties.enabled"
                    component={SwitchField}
                    placeholder="Attiva grant"
                    layout="horizontal"
                    type="checkbox"
                /> */}
                <h4 className="border-b-2 border-black">Attributi visualizzabili</h4>
                <div className="col-6 col-sm-12">
                    <Field name="properties_ids">
                        {(props) => {
                            // console.log(props);
                            return (
                                <PropertiesTreeWidget
                                    selectedNodes={props.input.value}
                                    onChange={(properties) => {
                                        // console.log(properties);
                                        props.input.onChange(properties.selectedNodes);
                                        // this.setState({
                                        //     selectedNodes:
                                        //         properties.selectedNodes,
                                        // });
                                    }}
                                />
                            );
                        }}
                    </Field>
                </div>
            </Tabs.Content>
            <Tabs.Content className="TabsContent" value="view_product_trees">
                {/* <Field
                    name="view_product_trees.enabled"
                    component={SwitchField}
                    placeholder="Attiva grant"
                    layout="horizontal"
                    type="checkbox"
                /> */}
                <h4 className="border-b-2 border-black">Classificazioni visualizzabili</h4>
                <Field name="view_product_trees_ids">
                    {(props) => (
                        <SelectMultipleField
                            // label="Classificazioni visualizzabili"
                            options={classificationFilter.options}
                            // labelClass="col-3 col-sm-12"
                            inputWrapperClass="col-6 col-sm-12"
                            value={props.input.value}
                            onChange={props.input.onChange}
                            meta={props.meta}
                        />
                    )}
                </Field>
            </Tabs.Content>
            <Tabs.Content className="TabsContent" value="view_products">
                {/* <Field
                    name="view_products.enabled"
                    component={SwitchField}
                    placeholder="Attiva grant"
                    layout="horizontal"
                    type="checkbox"
                /> */}
                <h4 className="border-b-2 border-black">Filtro prodotti</h4>

                <Field name="view_products_ids">
                    {(props) => {
                        const options = classificationFilter.options
                            .filter((o) => startsWith(o.value, 'custom:'))
                            .map((o) => {
                                return {
                                    ...o,
                                    value: o.value.replace('custom:', ''),
                                    // label: o.label.it_IT,
                                };
                            });

                        return (
                            <SelectMultipleField
                                // label="Classificazioni visualizzabili"
                                options={options}
                                // labelClass="col-3 col-sm-12"
                                inputWrapperClass="col-6 col-sm-12"
                                value={props.input.value}
                                onChange={props.input.onChange}
                                meta={props.meta}
                            />
                        );

                        // return (
                        //     <SelectField
                        //         // label="Classificazioni personalizzate visualizzabili"
                        //         options={options}
                        //         // labelClass="col-3 col-sm-12"
                        //         wrapperClassName="w-full"
                        //         placeholder="Seleziona"
                        //         // value={props.input.value}
                        //         // onChange={props.input.onChange}
                        //         input={props.input}
                        //         meta={props.meta}
                        //     />
                        // );
                    }}
                </Field>
            </Tabs.Content>
            <Tabs.Content className="TabsContent" value="delete_products">
                <h4 className="border-b-2 border-black">Abilita cancellazione prodotti</h4>
                <Field name="delete_products" type="checkbox">
                    {(props) => {
                        return (
                            <div className="form-group">
                                <label className="form-switch">
                                    <input
                                        type="checkbox"
                                        checked={props.input.checked}
                                        onChange={props.input.onChange}
                                    />
                                    <i className="form-icon" />
                                    Si/No
                                </label>
                            </div>
                        );
                    }}
                </Field>
            </Tabs.Content>
            {/* Field everprice_admin*/}
            {showEverpriceEnabled && (
                <Tabs.Content className="TabsContent" value="view_integrations">
                    {/*Everprice admin*/}
                    <h4 className="border-b-2 border-black">Visualizza il menù "Gestione EVERPRICE®"</h4>
                    <Field name="everprice_admin" type="checkbox">
                        {(props) => {
                            return (
                                <div className="form-group">
                                    <label className="form-switch">
                                        <input
                                            type="checkbox"
                                            checked={props.input.checked}
                                            onChange={props.input.onChange}
                                        />
                                        <i className="form-icon" />
                                        Si/No
                                    </label>
                                </div>
                            );
                        }}
                    </Field>
                    {/*Eveprice prices*/}
                    <h4 className="border-b-2 border-black">Dati EVERPRICE®</h4>
                    <Field name="everprice_prices" type="checkbox">
                        {(props) => {
                            return (
                                <div className="form-group">
                                    <label className="form-switch">
                                        <input
                                            type="checkbox"
                                            checked={props.input.checked}
                                            onChange={props.input.onChange}
                                        />
                                        <i className="form-icon" />
                                        Si/No
                                    </label>
                                </div>
                            );
                        }}
                    </Field>
                    {/*Everprice manage*/}
                    <h4 className="border-b-2 border-black">Funzioni amministrative EVERPRICE®</h4>
                    <Field name="everprice_manage" type="checkbox">
                        {(props) => {
                            return (
                                <div className="form-group">
                                    <label className="form-switch">
                                        <input
                                            type="checkbox"
                                            checked={props.input.checked}
                                            onChange={props.input.onChange}
                                        />
                                        <i className="form-icon" />
                                        Si/No
                                    </label>
                                </div>
                            );
                        }}
                    </Field>

                    {/*Eveprice distribution*/}
                    {
                        everpriceDistributionEnabled && !isGroup && (
                            <EverpriceDistribution />
                        )
                    }

                </Tabs.Content>
            )}

            {/*Grant giacenze*/}
            {showGiacenzeEnabled && (
                <Tabs.Content className="TabsContent" value="giacenze">
                    <h4 className="border-b-2 border-black">Abilita gestione Giacenze</h4>
                    <Field name="giacenze" type="checkbox">
                        {(props) => {
                            return (
                                <div className="form-group">
                                    <label className="form-switch">
                                        <input
                                            type="checkbox"
                                            checked={props.input.checked}
                                            onChange={props.input.onChange}
                                        />
                                        <i className="form-icon" />
                                        Si/No
                                    </label>
                                </div>
                            );
                        }}
                    </Field>
                </Tabs.Content>
            )}

        </Tabs.Root>
    )
}